import React from "react";
// import _ from 'lodash'
// import MultiLineText from './MultiLineText';
import BG from "./3.png";

export default ({ currentLang, selectedType }) => {
  const shouldDisplayByLang = selectLang => {
    return currentLang === selectLang ? "display" : "display-none";
  };
  const shouldDisplayByType = type => {
    return selectedType === type || selectedType === "all"
      ? "opacity-in"
      : "opacity-out";
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 329.4 363.4"
      className="site-plan-svg"
    >
      <g id="map">
        <image xlinkHref={BG} height="100%" width="100%" />
      </g>
      <g id="floorplan">
        <g id="studio" className={shouldDisplayByType("studio")}>
          <polygon
            id="_1A_2324"
            data-name="1A_2324"
            points="227.7 63.3 227.7 68.6 238.5 68.6 238.5 90.4 213 90.4 213 63.3 227.7 63.3"
            fill="#231f20"
          />
          <polygon
            id="_1A_2301"
            data-name="1A_2301"
            points="291.5 97.6 291.5 124.8 276.7 124.8 276.7 119.5 265.5 119.5 265.5 97.6 291.5 97.6"
            fill="#231f20"
          />
          <polygon
            id="_1A_2304"
            data-name="1A_2304"
            points="198.2 124.8 198.2 119.6 187.4 119.6 187.4 97.6 213 97.6 213 124.9 198.2 124.8"
            fill="#231f20"
          />
          <polygon
            id="_1A_2307"
            data-name="1A_2307"
            points="109 97.6 134.4 97.6 134.4 124.7 119.6 124.7 119.6 119.5 108.9 119.5 109 97.6"
            fill="#231f20"
          />
          <polygon
            id="_1A_2308"
            data-name="1A_2308"
            points="99.8 133.2 99.8 147.9 94.6 147.9 94.6 159.4 72.7 159.4 72.7 133.2 99.8 133.2"
            fill="#231f20"
          />
          <polygon
            id="_1A_2310"
            data-name="1A_2310"
            points="72.7 185.5 99.7 185.5 99.7 200.3 94.6 200.3 94.6 211.8 72.7 211.8 72.7 185.5"
            fill="#231f20"
          />
          <polygon
            id="_1A_2313"
            data-name="1A_2313"
            points="72.7 264.1 99.9 264.1 99.9 279 94.5 279 94.5 290.3 72.7 290.3 72.7 264.1"
            fill="#231f20"
          />
          <polygon
            id="_1A_2315"
            data-name="1A_2315"
            points="43.7 237.8 65.5 237.8 65.5 264.8 38.4 264.8 38.4 249.3 43.6 249.3 43.7 237.8"
            fill="#231f20"
          />
          <polygon
            id="_1A_2316"
            data-name="1A_2316"
            points="38.4 223.2 43.4 223.2 43.4 211.7 65.5 211.7 65.5 237.8 38.4 237.8 38.4 223.2"
            fill="#231f20"
          />
        </g>
        <g id="one-bedroom" className={shouldDisplayByType("one-bedroom")}>
          <polygon
            id="_1Cx_2302"
            data-name="1Cx_2302"
            points="239.1 97.6 265.3 97.6 265.3 133.9 250.3 133.9 250.3 129.5 239.1 129.5 239.1 97.6"
            fill="#231f20"
          />
          <polygon
            id="_1B_2303"
            data-name="1B_2303"
            points="213 97.6 239.1 97.6 239.1 124.9 212.9 124.9 213 97.6"
            fill="#231f20"
          />
          <polygon
            id="_1Cx_2305"
            data-name="1Cx_2305"
            points="160.6 97.6 186.7 97.6 186.7 133.8 171.8 133.8 171.8 129.5 160.6 129.5 160.6 97.6"
            fill="#231f20"
          />
          <rect
            id="_1B_2306"
            data-name="1B_2306"
            x="134.4"
            y="97.6"
            width="26.2"
            height="27.2"
            fill="#231f20"
          />
          <polygon
            id="_1B_2309"
            data-name="1B_2309"
            points="99.8 159.3 99.8 185 72.7 185 72.7 159.5 99.8 159.3"
            fill="#231f20"
          />
          <polygon
            id="_1Cx_2311"
            data-name="1Cx_2311"
            points="108.9 211.7 108.9 226.8 104.6 226.8 104.6 238 72.7 238 72.7 211.9 108.9 211.7"
            fill="#231f20"
          />
          <polygon
            id="_1B_2312"
            data-name="1B_2312"
            points="99.9 263.4 72.6 263.4 72.6 238 99.8 238 99.9 263.4"
            fill="#231f20"
          />
          <polygon
            id="_1Cx_2314"
            data-name="1Cx_2314"
            points="108.9 290.3 108.9 305.3 104.5 305.3 104.5 316.5 73.1 316.5 73.1 290.5 108.9 290.3"
            fill="#231f20"
          />
          <polygon
            id="_1D_2319"
            data-name="1D_2319"
            points="35.2 117.2 46.9 105.4 50.6 109.1 57.6 102.2 73 117.7 65.2 125.5 65.2 132.4 38.8 132.4 38.8 121.1 35.2 117.2"
            fill="#231f20"
          />
          <polygon
            id="_2302"
            data-name="2302"
            points="80.5 71.9 92.2 60.1 96 63.8 107.4 63.8 107.4 90 100.3 90 92.5 97.8 77.2 82.5 84.1 75.6 80.5 71.9"
            fill="#231f20"
          />
          <rect
            id="_1B_2323"
            data-name="1B_2323"
            x="187.3"
            y="63.3"
            width="25.2"
            height="27.14"
            fill="#231f20"
          />
        </g>
        <g id="two-bedroom" className={shouldDisplayByType("two-bedroom")}>
          <polygon
            id="_2B1_2318"
            data-name="2B1_2318"
            points="38.4 133.9 65.5 133.9 65.5 172 38.4 172 38.4 133.9"
            fill="#231f20"
          />
          <polygon
            id="_2A2_2317"
            data-name="2A2_2317"
            points="65.3 211.7 38.4 211.7 38.4 198.5 43.6 198.5 43.6 173 65.4 173 65.3 211.7"
            fill="#231f20"
          />
          <polygon
            id="_2A2_2321"
            data-name="2A2_2321"
            points="121.5 63.3 121.5 68.5 147.1 68.5 147.1 90.5 108.9 90.5 108.2 90.5 108.2 63.3 121.5 63.3"
            fill="#231f20"
          />
          <rect
            id="_2B1_2322"
            data-name="2B1_2322"
            x="148"
            y="63.3"
            width="38.3"
            height="26.66"
            fill="#231f20"
          />
        </g>
      </g>
      <g xmlns="http://www.w3.org/2000/svg" id="text">
        <g id="cn" className={shouldDisplayByLang("cn")}>
          <text
            transform="translate(272.7 139.8)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2301
          </text>
          <text
            transform="translate(247.1 139.8)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2302
          </text>
          <text
            transform="translate(221.9 139.8)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2303
          </text>
          <text
            transform="translate(194.2 139.8)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2304
          </text>
          <text
            transform="translate(168 139.8)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2305
          </text>
          <text
            transform="translate(141.7 139.8)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2306
          </text>
          <text
            transform="translate(116.6 135.1)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2307
          </text>
          <text
            transform="translate(104.9 149.9)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2308
          </text>
          <text
            transform="translate(110.4 175.9)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2309
          </text>
          <text
            transform="translate(110.4 202.3)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2310
          </text>
          <text
            transform="translate(110.4 227.7)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2311
          </text>
          <text
            transform="translate(110.4 253.8)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2312
          </text>
          <text
            transform="translate(110.4 280.1)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2313
          </text>
          <text
            transform="translate(110.4 306.7)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2314
          </text>
          <text
            transform="translate(73.7 62)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2320
          </text>
          <text
            transform="translate(28.8 103.6)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2319
          </text>
          <text
            transform="translate(122.4 49.8)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2321
          </text>
          <text
            transform="translate(161.6 49.8)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2322
          </text>
          <text
            transform="translate(194.4 49.8)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2323
          </text>
          <text
            transform="translate(219.5 49.8)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2324
          </text>
          <text
            transform="translate(19 156.6)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2318
          </text>
          <text
            transform="translate(19 194.7)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2317
          </text>
          <text
            transform="translate(19 227.5)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2316
          </text>
          <text
            transform="translate(19 254.1)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2315
          </text>
          <text
            transform="translate(181.7 219.3)"
            font-size="10"
            fill="#58595b"
            font-family="Termina-Bold, Termina Bold"
          >
            <tspan font-weight="700">3</tspan>
            <tspan
              x="5.1"
              y="0"
              font-family="STHeitiTC-Medium, STHeitiTC Medium"
            >
              楼
            </tspan>
          </text>
        </g>
        <g id="ru" className={shouldDisplayByLang("ru")}>
          <text
            transform="translate(272.6 139.8)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2301
          </text>
          <text
            transform="translate(247 139.8)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2302
          </text>
          <text
            transform="translate(221.8 139.8)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2303
          </text>
          <text
            transform="translate(194.1 139.8)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2304
          </text>
          <text
            transform="translate(167.9 139.8)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2305
          </text>
          <text
            transform="translate(141.6 139.8)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2306
          </text>
          <text
            transform="translate(116.5 135.1)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2307
          </text>
          <text
            transform="translate(104.8 149.9)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2308
          </text>
          <text
            transform="translate(110.3 175.9)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2309
          </text>
          <text
            transform="translate(110.3 202.3)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2310
          </text>
          <text
            transform="translate(110.3 227.7)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2311
          </text>
          <text
            transform="translate(110.3 253.8)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2312
          </text>
          <text
            transform="translate(110.3 280.1)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2313
          </text>
          <text
            transform="translate(110.3 306.7)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2314
          </text>
          <text
            transform="translate(73.7 62)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2320
          </text>
          <text
            transform="translate(28.7 103.6)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2319
          </text>
          <text
            transform="translate(122.4 49.8)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2321
          </text>
          <text
            transform="translate(161.6 49.8)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2322
          </text>
          <text
            transform="translate(194.3 49.8)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2323
          </text>
          <text
            transform="translate(219.4 49.8)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2324
          </text>
          <text
            transform="translate(19 156.6)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2318
          </text>
          <text
            transform="translate(19 194.7)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2317
          </text>
          <text
            transform="translate(19 227.5)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2316
          </text>
          <text
            transform="translate(19 254.1)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2315
          </text>
          <text
            transform="translate(173.8 219.3)"
            font-size="11"
            fill="#58595b"
            font-family="Helvetica-Bold, Helvetica"
            font-weight="700"
          >
            3-Й ЭТАЖ
          </text>
        </g>
        <g id="en" className={shouldDisplayByLang("en")}>
          <text
            transform="translate(272.7 140)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2301
          </text>
          <text
            transform="translate(247.1 140)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2302
          </text>
          <text
            transform="translate(221.9 140)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2303
          </text>
          <text
            transform="translate(194.2 140)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2304
          </text>
          <text
            transform="translate(168 140)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2305
          </text>
          <text
            transform="translate(141.7 140)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2306
          </text>
          <text
            transform="translate(116.6 135.2)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2307
          </text>
          <text
            transform="translate(104.9 150.1)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2308
          </text>
          <text
            transform="translate(110.4 176.1)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2309
          </text>
          <text
            transform="translate(110.4 202.4)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2310
          </text>
          <text
            transform="translate(110.4 227.9)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2311
          </text>
          <text
            transform="translate(110.4 253.9)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2312
          </text>
          <text
            transform="translate(110.4 280.3)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2313
          </text>
          <text
            transform="translate(110.4 306.9)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2314
          </text>
          <text
            transform="translate(73.7 62.1)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2320
          </text>
          <text
            transform="translate(28.8 103.7)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2319
          </text>
          <text
            transform="translate(122.4 50)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2321
          </text>
          <text
            transform="translate(161.6 50)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2322
          </text>
          <text
            transform="translate(194.4 50)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2323
          </text>
          <text
            transform="translate(219.5 50)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2324
          </text>
          <text
            transform="translate(19 156.8)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2318
          </text>
          <text
            transform="translate(19 194.9)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2317
          </text>
          <text
            transform="translate(19 227.6)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2316
          </text>
          <text
            transform="translate(19 254.2)"
            font-size="5.88"
            fill="#808285"
            font-family="Helvetica, Helvetica"
          >
            2315
          </text>
          <text
            transform="translate(170.6 219.4)"
            font-size="10"
            fill="#58595b"
            font-family="Termina-Bold, Termina Bold"
            font-weight="700"
          >
            3rd Floor
          </text>
        </g>
      </g>
    </svg>
  );
};



// WEBPACK FOOTER //
// ./src/data/PhuketSkypark/sitePlan/svg/b/3.js